import { getCookie } from '../utils/cookieManager';
function getLanguage(): 'en' | 'zh' {
  if (typeof window === 'undefined') {
    return 'en';
  }

  // Check URL parameters first
  const urlParams = new URLSearchParams(window.location.search);
  let lang = urlParams.get('lang');

  // If no URL param, check cookies
  if(!lang) {
    const cookieLang = getCookie('lang');
    if (cookieLang == 'mcHbFvVz6GasaoYXRD6O4Q==') {
      lang = 'zh';
    } else if (cookieLang) {
      lang = 'en';
    }
  }
  
  if (!lang) {
    lang = window.localStorage.getItem('nowtv_lang') || 'en';
  }
  
  // Normalize language
  lang = lang.toLowerCase();
  if (lang.startsWith('zh') || lang === '_ch') {
    window.localStorage.setItem('nowtv_lang', 'zh');
    return 'zh';
  }
  window.localStorage.setItem('nowtv_lang', 'en');
  return 'en';
}

const language = getLanguage();
export default language;